const LiquifyHelper = {
    moneyFormat: (value, minor = true) => {
        const formatter = new Intl.NumberFormat(Shopify.locale + '-' + Shopify.country, {
            style: 'currency',
            currency: Shopify.currency.active,
        });

        value = minor ? value / 100 : value;

        return formatter.format(value);
    },

    triggerClick: function (el) {
        if(!(el instanceof HTMLElement)) {
            console.info(el + ' must be an instance of HTMLElement')
            return
        }
        const ev = new KeyboardEvent("keydown",{
            code: 'Enter',
            key: 'Enter',
            charCode: 13,
            keyCode: 13,
            view: window,
            bubbles: true
        });

        el.dispatchEvent(ev);
    },

    triggerClickById: (id) => {
        const el = document.getElementById(id)
        LiquifyHelper.triggerClick(el)
    },

    triggerClickByClass: (className) => {
        const elList = document.getElementsByClassName(className)
        for (const el of elList) {
            LiquifyHelper.triggerClick(el)
        }
    }
};
